import { render, staticRenderFns } from "./HoldHandler.vue?vue&type=template&id=0422ae0f&"
import script from "./HoldHandler.vue?vue&type=script&lang=js&"
export * from "./HoldHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports